import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, indianProjectsBaseURL, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { GET_ANNOUNCEMENTS, GET_ANNOUNCEMENTS_SUCCESS, GET_ANNOUNCEMENTS_ERROR } from '../../actionType.js';
import apiCall from '../../apiCall.js';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getAnnoucements({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/adib/user/announcements`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload?.urlParam,
        pageSize: Constant?.TABLE_PAGE_SIZE,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_ANNOUNCEMENTS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_ANNOUNCEMENTS_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_ANNOUNCEMENTS_ERROR, payload: error });
  }
}

export function* watchGetAnnoucements() {
  yield takeEvery(GET_ANNOUNCEMENTS, getAnnoucements);
}

function* getAnnoucementsSaga() {
  yield all([fork(watchGetAnnoucements)]);
}

export default getAnnoucementsSaga;
